import { Outlet } from "react-router-dom";

function ContractsMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default ContractsMain;